// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Initial true-up layout route. The per-currency status board renders at
 * /accounting/initial-true-up (index) and the per-currency initial true-up workflow at
 * /accounting/initial-true-up/<iso>, both through the child outlet.
 */
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/accounting/initial-true-up')({
  component: Outlet,
});
